import { Permission } from '@procureai/permissions';

import { SearchConfigItem } from '../../types/SearchConfigItem.ts';
import { SearchDomain } from '../../types/SearchDomain.ts';
import { SearchIndex } from '../../types/SearchIndex.ts';
import { SearchIndexConfigFactoryOptions } from '../../types/SearchIndexConfigFactoryOptions.ts';

import { contractSearchIndexConfig } from './contract.ts';
import { purchaseOrderSearchIndexConfig } from './purchaseOrder.ts';
import { purchaseRequisitionSearchIndexConfig } from './purchaseRequisition.ts';
import { sourcingProjectSearchIndexConfig } from './sourcingProject.ts';

type SearchConfigFactory = (options: SearchIndexConfigFactoryOptions) => SearchConfigItem;

const searchConfigFactoryMap: Record<SearchDomain, SearchConfigFactory> = {
  [SearchDomain.PURCHASE_ORDER]: purchaseOrderSearchIndexConfig,
  [SearchDomain.PURCHASE_REQUISITION]: purchaseRequisitionSearchIndexConfig,
  [SearchDomain.CONTRACT]: contractSearchIndexConfig,
  [SearchDomain.SOURCING_PROJECT]: sourcingProjectSearchIndexConfig,
};

const searchDomainIndexMap: Record<SearchDomain, SearchIndex> = {
  [SearchDomain.PURCHASE_ORDER]: SearchIndex.PURCHASE_ORDER,
  [SearchDomain.PURCHASE_REQUISITION]: SearchIndex.PURCHASE_REQUISITION,
  [SearchDomain.CONTRACT]: SearchIndex.CONTRACT,
  [SearchDomain.SOURCING_PROJECT]: SearchIndex.SOURCING_PROJECT,
};

export const getSearchIndexName = (domain: SearchDomain): string => {
  return searchDomainIndexMap[domain];
};

export const getSearchIndexConfigFactory = (domain: SearchDomain): SearchConfigFactory => {
  return searchConfigFactoryMap[domain];
};

const searchConfigNeedsMap: Record<SearchDomain, Permission> = {
  [SearchDomain.PURCHASE_ORDER]: Permission.SearchIndexOrdersView,
  [SearchDomain.PURCHASE_REQUISITION]: Permission.SearchIndexRequisitionsView,
  [SearchDomain.CONTRACT]: Permission.SearchIndexContractsView,
  [SearchDomain.SOURCING_PROJECT]: Permission.SearchIndexSourcingView,
};

export const getSearchDomainPermission = (domain: SearchDomain): Permission => {
  return searchConfigNeedsMap[domain];
};
